import { render, staticRenderFns } from "./block_ip.vue?vue&type=template&id=37ef8d78&"
import script from "./block_ip.vue?vue&type=script&lang=js&"
export * from "./block_ip.vue?vue&type=script&lang=js&"
import style0 from "./block_ip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports